'use client'
import { useLanguage } from '@/context/LanguageProvider'
import { useTheme } from '@/context/ThemeProvider'
import useFonts from '@/hooks/useFonts'

export default function Restricted () {
  const { lang } = useLanguage()
  const { colors } = useTheme()
  const { fonts } = useFonts()
  return (
    <div className='text-center mt-8 h-full'>
      <h1 className='text-xl' style={{ fontFamily: fonts.body }}>
        {lang === 'ar' ? 'عفوًا، حدث خطأ ما.' : 'Ops something went wrong.'}
      </h1>
      <p
        className='text-base'
        style={{ color: colors.contrast75, fontFamily: fonts.body }}
      >
        {lang === 'ar'
          ? 'الرجاء المحاولة مرة أخرى لاحقًا.'
          : 'Please try again later.'}
      </p>
    </div>
  )
}
